import React, { useEffect, useState } from "react";
import { List, ListItem, ListItemText } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CircularProgress from "@mui/material/CircularProgress";
import {
  ATTRUBUTE_CATEGORIES_LIST,
  VEHICLE_ATTRIBUTES,
} from "../../services/Constants";

const VehicleAttributesTab = ({ vehicleData, isLoading }) => {
  const [vehicleAttributes, setVehicleAttributes] = useState([]);

  const { overview: { attributes } = {} } = vehicleData;

  const getAttributeLabel = (attrId) => {
    if (!!attrId) {
      return VEHICLE_ATTRIBUTES?.[attrId]?.label || attrId;
    }
  };

  const getAttributeCategoryId = (attrId) => {
    if (!!attrId) {
      return VEHICLE_ATTRIBUTES?.[attrId]?.category?.id || attrId;
    }
  };

  useEffect(() => {
    if (attributes) {
      const items = [];
      for (const [key, value] of Object.entries(attributes)) {
        console.log(`${key}: ${value}`);
        items.push({ key, value });
      }
      setVehicleAttributes(items);
    } else {
      setVehicleAttributes([]);
    }
  }, [attributes]);

  const Category = ({ id, label }) => {
    const [expanded, setExpanded] = useState(true);
    const listItems = vehicleAttributes.filter(
      (i) => getAttributeCategoryId(i.key) === id
    );
    return (
      <Accordion expanded={expanded} onChange={() => setExpanded(!expanded)}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>{label}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <List>
            {listItems?.length
              ? listItems.map((i, index) => (
                  <ListItem divider>
                    <ListItemText
                      primary={getAttributeLabel(i.key)}
                      secondary={i.value}
                    />
                  </ListItem>
                ))
              : "No data"}
          </List>
        </AccordionDetails>
      </Accordion>
    );
  };

  if (isLoading) return <CircularProgress />;

  return (
    <>
      {ATTRUBUTE_CATEGORIES_LIST && ATTRUBUTE_CATEGORIES_LIST.length
        ? ATTRUBUTE_CATEGORIES_LIST.map((cat) => <Category {...cat} />)
        : null}
    </>
  );
};

export default VehicleAttributesTab;
